import { alpha } from '@mui/system';
import { CustomerNameBackground } from '../../assets';
import { themeObject as theme } from 'lib';

export const styles = {
    mainContainer: {
        py: '161px',
        backgroundImage: `url(${CustomerNameBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'top',
        height: '100vh',
        overflow: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
    },
    container: {
        boxShadow: `0px 1px 18px 0px ${alpha(
            theme.palette.grayScale[700],
            0.12
        )},0px 6px 10px 0px ${alpha(
            theme.palette.grayScale[700],
            0.14
        )},0px 3px 5px -1px ${alpha(theme.palette.grayScale[700], 0.2)}`,
        backgroundColor: theme.palette.background.default,
        borderRadius: '20px',
        padding: '151px 82px 195px 82px',
        textAlign: 'center',
    },
    formContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    formControl: {
        mt: '4px',
    },
    image: {
        marginBottom: '32px',
        height: '95px',
        width: '398.75px',
    },
    heading: {
        fontWeight: 600,
        fontSize: '28px',
        lineHeight: '32.87px',
        color: theme.palette.primary[700],
        alignSelf: 'center',
        marginBottom: '32px',
    },
    textField: {
        '& .MuiInputBase-input': {
            border: `1px solid ${theme.palette.grayScale[500]}`,
            height: '40px',
            padding: '0px 8px',
            borderRadius: '4px',
        },
    },
    button: {
        marginTop: '20px',
        boxShadow: 'none',
    },
    formLabelContainerStyles: {
        display: 'flex',
        width: '100%',
    },
};
